import React from 'react';
import { Avatar, Select, TreeSelect, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import { setAddingExistingUserValues } from '~/slices/state';
import { useGetContactsApi } from '~/controllers/contacts';

import { ArrowDownIcon, ArrowIcon } from '~/img';
import createUid from '~/utils/createUid';
function ContactsDropDown({ excludedRoles, onSelect }: { excludedRoles?: string; onSelect?: (contact: any) => void }) {
  const { Option } = Select;
  const { data: options } = useGetContactsApi(excludedRoles);
  const optionss = options?.map((item: any) => {
    const newContacts = item?.contacts?.map((ele: any) => {
      ele.refId = createUid();
      return {
        title: `${ele?.firstName}  ${ele?.lastName}`,
        ...ele,
        value: JSON.stringify(ele),
      };
    });
    return {
      ...item,
      contacts: newContacts,
      value: item?.type,
    };
  });
  const dispatch = useDispatch();
  function dropDownHandler(values: any) {
    const parsedValues = JSON.parse(values);
    dispatch(setAddingExistingUserValues(parsedValues));
    onSelect?.(parsedValues);
  }

  return (
    <>
      <Typography.Title level={4}>* Select the contact that you want to copy profile from </Typography.Title>
      <TreeSelect
        onChange={(values: any) => dropDownHandler(values)}
        style={{ width: 520, marginBottom: '24px' }}
        fieldNames={{ children: 'contacts' }}
        treeData={optionss}
        treeDefaultExpandAll
        switcherIcon={
          <div style={{ width: 500, zIndex: 1, position: 'absolute' }}>
            <ArrowDownIcon
              style={{
                position: 'absolute',
                left: 0,
                top: -7,
                zIndex: 999,
                width: 500,
                height: 30,
              }}
            />
          </div>
        }
      />
    </>
  );
}
export default ContactsDropDown;
